var map = {
	"./agility.png": 2572,
	"./attack.png": 8645,
	"./construction.png": 2770,
	"./cooking.png": 2553,
	"./crafting.png": 9179,
	"./defence.png": 8077,
	"./farming.png": 2145,
	"./firemaking.png": 7138,
	"./fishing.png": 1075,
	"./fletching.png": 5533,
	"./herblore.png": 2588,
	"./hitpoints.png": 423,
	"./hunter.png": 7495,
	"./magic.png": 5108,
	"./mining.png": 5969,
	"./overall.png": 8710,
	"./prayer.png": 3864,
	"./ranged.png": 2284,
	"./runecraft.png": 7755,
	"./slayer.png": 3147,
	"./smithing.png": 5350,
	"./strength.png": 1574,
	"./thieving.png": 2741,
	"./woodcutting.png": 4476
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1853;